import { apiFetch } from "./client";

/** Configuration publique du site (non sensible). */

export type HomeVariant = { variant: string };

/** Variante de page d'accueil active (publique, pour la landing). */
export function getHomeVariant() {
  return apiFetch<HomeVariant>("/home-variant");
}

/** Variante du panneau simulation travaux (publique, lue par le résultat DPE). */
export function getPanelVariant() {
  return apiFetch<HomeVariant>("/scenarios-panel-variant");
}

/** Drapeaux de mise en page (publiques) — pilotés via /admin/flags. */
export type UiFlags = {
  show_simulation_details_tab: boolean;
};

export function getUiFlags() {
  return apiFetch<UiFlags>("/ui-flags");
}
